import React, { Component } from "react";
import logologin from "../../Comman/images/alecom.png";
import { Link,useLocation } from "react-router-dom";
import Auth from "../../auth";
import { withNamespaces } from "react-i18next";
import { checkPermission } from "../../auth";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";

//import {baseUrlMap} from '../../Comman/apiEndPoints'
class SuperAdminLeftMenuComponent extends Component {
  constructor(props) {
    super(props);

    this.logout = this.logout.bind(this);
  }
  componentDidMount() {}
  logout() {
    console.log(this.props);
    Auth.signout();
    this.props.logout();

    
  }
  // openMapApplication = () => {
  //     var href = baseUrlMap + "#/authentication/Login";
  //     var ID =  sessionStorage.getItem('SuperAdminUserID')
  //     const newWindow = window.open(href+ '?UserId='+ID, '_blank', 'noopener,noreferrer')
  //       if (newWindow) newWindow.opener = null
  //   }

  render() {
    const { t } = this.props;
    let { superMapUser } = false;
    var userId = sessionStorage.getItem("SuperAdminUserID");
    //const Permissions = JSON.parse(sessionStorage.getItem('Permissions'));
      //const { pathname: currentPath } = useLocation();
    return (
      <div className="left-menu-main">
        <Sidebar backgroundColor="#184c73" width="260px">
          {/*     <img  src={logologin} alt="" className="image-menu" /> */}
          <Menu 
            menuItemStyles={{
              subMenuContent: {
                backgroundColor: "#3f7ba8ff", // Change this to your desired color
                color: "#ffffff !important", // Change submenu text color
              },
              button: ({ level, active, disabled }) => ({
                "&:hover": {
                  backgroundColor: "#86c0f0ef", // Change this to your desired hover color
                  outline: "none",
                  borderStyle: "solid", // Optionally change text color on hover
                },
              }),
            }}
          >
            {checkPermission("Dashboard") && <MenuItem
              component={<Link to="/superadmin/dashboard" />}
              style={{ marginTop: "100px" }}
              icon={<i className="fa fa-home"> </i>}
            >
              {checkPermission("Dashboard") && <span>{t("Menu.Home")}</span>}
            </MenuItem>}
            {(checkPermission('Profile_Pending_List_For_Approval')||checkPermission('Incoming_Alarm_List') || checkPermission('First_Responders_List') || checkPermission('Add_First_Responder')|| checkPermission('Pending_List')||checkPermission('Rejected_List') ||checkPermission('Deleted_List') ) && <SubMenu
              rootStyles={{ color: "lightblue" }}
              icon={<i className="fas fa-running" aria-hidden="true"></i>}
              label={t("Menu.First Responder")}
            >
             {checkPermission("First_Responders_List") && <MenuItem component={<Link to="/superadmin/FirstResponder" />}>
                {" "}
                {checkPermission("First_Responders_List") && (
                  <span>{t("Menu.First Responder")}</span>
                )}
              </MenuItem>}
             {checkPermission("Add_First_Responder") && <MenuItem component={<Link to="/superadmin/addFirstResponder" />}>
                {" "}
                {checkPermission("Add_First_Responder") && (
                  <span>{t("Menu.Add First Responder")}</span>
                )}
              </MenuItem>}
             {checkPermission("Pending_List") && <MenuItem component={<Link to="/superadmin/pendingFirstResponder" />}>
                {" "}
                {checkPermission("Pending_List") && (
                  <span>{t("Menu.Pending List")}</span>
                )}
              </MenuItem>}
              {checkPermission("Rejected_List") &&<MenuItem
                component={<Link to="/superadmin/rejectedFirstResponder" />}
              >
                {checkPermission("Rejected_List") && (
                  <span>{t("Menu.Rejected List")}</span>
                )}
              </MenuItem>}
             {checkPermission("Deleted_List") && <MenuItem
                component={<Link to="/superadmin/deletedFirstResponder" />}
              >
                {" "}
                {checkPermission("Deleted_List") && (
                  <span>{t("Menu.Deleted List")}</span>
                )}
              </MenuItem>}
              {checkPermission("Incoming_Alarm_List") && <MenuItem
                component={<Link to="/superadmin/incoming-alarm-list" />}
              >
                {" "}
                {checkPermission("Incoming_Alarm_List") && (
                  <span>{t("Menu.incoming alarm list")}</span>
                )}
              </MenuItem>}
             {checkPermission("Profile_Pending_List_For_Approval") && <MenuItem
                component={
                  <Link to="/superadmin/pendingEditProfileForApproval" />
                }
              >
                {checkPermission("Profile_Pending_List_For_Approval") && (
                  <span>{t("Menu.Edit Profile-Pending For Approval")}</span>
                )}
              </MenuItem>}
            </SubMenu>}
            {checkPermission("Settings") &&<MenuItem
              component={<Link to="/superadmin/settingsFirstResponder" />}
              icon={<i className="fa fa-cog" aria-hidden="true"></i>}
            >
              {" "}
              {checkPermission("Settings") && <span>{t("Menu.Settings")}</span>}
            </MenuItem>}
            {(checkPermission('FAQ_Setting') || checkPermission('General_Setting') || checkPermission('Email_Subject_Setting') || checkPermission('Logo_Setting')  || checkPermission('SMTP_Setting') || checkPermission('Email_Setting') || checkPermission('Contact_Setting') || checkPermission('Monthly_Report_Subscribers') || checkPermission('Tetra_Resources_List') || checkPermission('Monthly_Report') || checkPermission('Authentication_Method_Setting') || checkPermission('Company_Branding') || checkPermission('Permissions') || checkPermission('Regions') || checkPermission('Crousel_Settings') && checkPermission('Terms_And_Conditions_Setting') && checkPermission('Privacy_Policy_Settings')) && <SubMenu
              icon={<i className="fa fa-cog" aria-hidden="true"></i>}
              label={t("Menu.Main Settings")}
            >
             {checkPermission("Terms_And_Conditions_Setting") && <MenuItem
                component={<Link to="/superadmin/terms-of-use-setting" />}
              >
                {" "}
                {checkPermission("Terms_And_Conditions_Setting") && (
                  <span>{t("Menu.Terms & Condition setting")}</span>
                )}
              </MenuItem>}
              {checkPermission("Privacy_Policy_Settings") && <MenuItem
                component={<Link to="/superadmin/Privacy-Policy-Setting" />}
              >
                {" "}
                {checkPermission("Privacy_Policy_Settings") && (
                  <span>{t("Menu.Privacy Policy Setting")}</span>
                )}
              </MenuItem>}
            { checkPermission("Crousel_Settings") && <MenuItem component={<Link to="/superadmin/carousel-setting" />}>
                {" "}
                {checkPermission("Crousel_Settings") && (
                  <span>{t("Menu.Carousel setting")}</span>
                )}
              </MenuItem>}
              { checkPermission("Permissions") && <MenuItem component={<Link to="/superadmin/permissions" />}>
                {" "}
                {checkPermission("Permissions") && (
                  <span>Permissions</span>
                )}
              </MenuItem>}
              {checkPermission("Regions") &&<MenuItem component={<Link to="/superadmin/region" />}>
                {" "}
                {checkPermission("Regions") && (
                  <span>{t("Region.Regions")}</span>
                )}
              </MenuItem>}
             {checkPermission("Company_Branding") && <MenuItem component={<Link to="/superadmin/companyBranding" />}>
                {" "}
                {checkPermission("Company_Branding") && (
                  <span>Company Branding</span>
                )}
              </MenuItem>}
              {checkPermission("Authentication_Method_Setting") &&  <MenuItem component={<Link to="/superadmin/userAuthList" />}>
                {" "}
                {checkPermission("Authentication_Method_Setting") && (
                  <span>Users Authentication List</span>
                )}
              </MenuItem>}
             {checkPermission("Tetra_Resources_List") && <MenuItem component={<Link to="/superadmin/tetraResources" />}>
                {checkPermission("Tetra_Resources_List") && (
                  <span>Tetra Resources</span>
                )}
              </MenuItem>}
              {checkPermission("Monthly_Report") && <MenuItem component={<Link to="/superadmin/monthlyReport" />}>
                {" "}
                {checkPermission("Monthly_Report") && (
                  <span>{t("Region.MonthlyReport")}</span>
                )}
              </MenuItem>}
              {checkPermission("Monthly_Report_Subscribers") &&<MenuItem component={<Link to="/superadmin/reportsubscribers" />}>
                {checkPermission("Monthly_Report_Subscribers") && (
                  <span>{t("Region.Monthly Report Subscribers")}</span>
                )}
              </MenuItem>}
              {checkPermission("Contact_Setting") &&  <MenuItem component={<Link to="/superadmin/contact-setting" />}>
                {checkPermission("Contact_Setting") && (
                  <span>{t("Menu.Contact setting")}</span>
                )}
              </MenuItem>}
             {checkPermission("Email_Setting") &&  <MenuItem component={<Link to="/superadmin/email-setting" />}>
                {checkPermission("Email_Setting") && (
                  <span>{t("Menu.Email setting")}</span>
                )}
              </MenuItem>}
             {checkPermission("SMTP_Setting") && <MenuItem component={<Link to="/superadmin/SMTP-setting" />}>
                {checkPermission("SMTP_Setting") && (
                  <span>SMTP {t("Menu.Setting")}</span>
                )}
              </MenuItem>}
              {checkPermission("Logo_Setting") &&<MenuItem component={<Link to="/superadmin/logo-setting" />}>
                {checkPermission("Logo_Setting") && (
                  <span>
                    {t("Email Setting.Logo Setting")}
                  </span>
                )}
              </MenuItem>}
              {checkPermission("Email_Subject_Setting") &&  <MenuItem
                component={<Link to="/superadmin/email-subject-setting" />}
              >
                {checkPermission("Email_Subject_Setting") && (
                  <span>{t("Menu.Email Subject Setting")}</span>
                )}
              </MenuItem>}
              {checkPermission("General_Setting") &&<MenuItem component={<Link to="/superadmin/general-setting" />}>
                {checkPermission("General_Setting") && (
                  <span>{t("Menu.General setting")}</span>
                )}
              </MenuItem>}
             {checkPermission("FAQ_Setting") && <MenuItem component={<Link to="/superadmin/FAQ-Setting" />}>
                {checkPermission("FAQ_Setting") && (
                  <span>{t("Menu.FAQ Setting")}</span>
                )}
              </MenuItem>}
            </SubMenu>}
            {(checkPermission('Add_New_Notification') || checkPermission('View_Notification') ) && <SubMenu
              icon={<i className="fa fa-bell-o" aria-hidden="true"></i>}
              label={t("Menu.Notification Settings")}
            >
              {checkPermission("Add_New_Notification") && <MenuItem component={<Link to="/superadmin/addNotification" />}>
                {" "}
                {checkPermission("Add_New_Notification") && (
                  <span>{t("Menu.Add New Notification")}</span>
                )}
              </MenuItem>}
             {checkPermission("View_Notification") &&  <MenuItem component={<Link to="/superadmin/detailedNotification" />}>
                {" "}
                {checkPermission("View_Notification") && (
                  <span>
                    {t("Menu.View Notifications")}
                  </span>
                )}
              </MenuItem>}
            </SubMenu>}
            {(checkPermission('Reject_Feedback_Answer') || checkPermission('Reject_Feedback_Questions') || checkPermission('Application_Feedback_Answers') || checkPermission('Application_Feedback_Question') || checkPermission('Add_Feedback_Question_Details') || checkPermission('Alarm_Feedback_Questions') ) && <SubMenu
              icon={<i className="fa fa-comments-o" aria-hidden="true"></i>}
              label={t("Menu.Feedback Settings")}
            >
             {checkPermission("Add_Feedback_Question_Details") && <MenuItem component={<Link to="/superadmin/feedback-setting" />}>
                {" "}
                {checkPermission("Add_Feedback_Question_Details") && (
                  <span>
                    {t("Menu.Add Feedback Question Details")}
                  </span>
                )}
              </MenuItem>}
              {checkPermission("Alarm_Feedback_Questions") && <MenuItem component={<Link to="/superadmin/detailedfeedback-setting" />}>
                {" "}
                {checkPermission("Alarm_Feedback_Questions") && (
                  <span>
                    {t("Menu.alarm feedback question")}
                  </span>
                )}
              </MenuItem>}
             {checkPermission("Alarm_Feedback_Answers") && <MenuItem component={<Link to="/superadmin/alarmfeedbackAnswerList" />}>
                {" "}
                {checkPermission("Alarm_Feedback_Answers") && (
                  <span>
                    {t("Menu.Alarm Feedback answer list")}
                  </span>
                )}
              </MenuItem>}
             {checkPermission("Application_Feedback_Question") && <MenuItem component={<Link to="/superadmin/detailedfeedback-setting-for-app" />}>
                {" "}
                {checkPermission("Application_Feedback_Question") && (
                  <span>
                    {t("Menu.application feedback question")}
                  </span>
                )}
              </MenuItem>}
              {checkPermission("Application_Feedback_Answers") &&<MenuItem component={<Link to="/superadmin/appfeedbackAnswerList" />}>
                {" "}
                {checkPermission("Application_Feedback_Answers") && (
                  <span>Application Feedback Answers</span>
                )}
              </MenuItem>}
            
             {checkPermission("Reject_Feedback_Questions") && <MenuItem component={<Link to="/superadmin/reject-feedback-details" />}>
                {checkPermission("Reject_Feedback_Questions") && (
                  <span>
                    {t("Menu.Reject Feedback Questions")}
                  </span>
                )}
              </MenuItem>}
              {checkPermission("Reject_Feedback_Answer") &&<MenuItem component={<Link to="/superadmin/reject-feedback-answer" />}>
                {" "}
                {checkPermission("Reject_Feedback_Answer") && (
                  <span>
                    {t("Menu.Reject Feedback answer")}
                  </span>
                )}
              </MenuItem>}
            </SubMenu>}
           { (checkPermission('Predefined_Text') || checkPermission('Alarm_Fields') || checkPermission('Alarm_Status_Colours') || checkPermission('Alarm_Audio_Setting')  || checkPermission('Alarm_Rules')) && <SubMenu
              icon={<i className="fa fa-comments-o" aria-hidden="true"></i>}
              label={t("Menu.Alarm Setting")}
            >
              {checkPermission("Alarm_Rules") && <MenuItem component={<Link to="/superadmin/alarm-rules" />}>
                {" "}
                {checkPermission("Alarm_Rules") && (
                  <span>
                    {t("Menu.Alarm Rules")}
                  </span>
                )}
              </MenuItem>}
                
             {checkPermission("Alarm_Audio_Setting") && <MenuItem component={<Link to="/superadmin/alarm-sound-setting" />}>
                {" "}
                {checkPermission("Alarm_Audio_Setting") && (
                  <span>
                    {t("Menu.Alarm Audio setting")}
                  </span>
                )}
              </MenuItem>}
              {checkPermission("Alarm_Status_Colours") &&<MenuItem component={<Link to="/superadmin/alarm-status" />}>
                {" "}
                {checkPermission("Alarm_Status_Colours") && (
                  <span>
                    {t("Menu.Alarm status color")}
                  </span>
                )}
              </MenuItem>}
             {checkPermission("Alarm_Fields") && <MenuItem component={<Link to="/superadmin/send-profile" />}>
                {" "}
                {checkPermission("Alarm_Fields") && (
                  <span>
                    {t("Menu.Alarm fields")}
                  </span>
                )}
              </MenuItem>}
             {checkPermission("Predefined_Text") && <MenuItem component={<Link to="/superadmin/predefined-text" />}>
                {" "}
                {checkPermission("Predefined_Text") && (
                  <span>
                    {t("Menu.Predefined Text")}
                  </span>
                )}
              </MenuItem>}
            </SubMenu>}
            <MenuItem onClick={this.logout}
              icon={<i className="fa fa-sign-out" aria-hidden="true"></i>}
            >
              <span style={{ color: "white" }} onClick={this.logout}>
                {t("Menu.Logout")}
              </span>
            </MenuItem>
          </Menu>
        </Sidebar>
      </div>
    );
  }
}

export default withNamespaces()(SuperAdminLeftMenuComponent);
